/* Venturi two-stage in-drawer and pre-checkout upsell.
   Do not replace bundle items or mutate gift entitlements. */
(() => {
  if (window.venturiPersimmonUpsellInstalled) return;
  window.venturiPersimmonUpsellInstalled = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-venturi-persimmon-add]');
    if (!button || button.disabled) return;
    if (window.venturiCartReplacementInProgress) return;
    const variantId = Number(button.dataset.variantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
    const panel = button.closest('.vp-upsell');
    const status = panel?.querySelector('[data-venturi-upsell-notice]');
    const initialLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({
          items:[{id:variantId,quantity:1}],
          sections:['cart-drawer','cart-icon-bubble'],
          sections_url:window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.errors) throw new Error(data.description || 'Unable to add this product.');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections?.['cart-drawer']) {
        drawer.renderContents({...data,id:variantId});
      } else {
        window.location.assign(root + 'cart');
      }
    } catch(err) {
      button.disabled = false;
      button.textContent = initialLabel;
      if (status) status.textContent = err.message || 'Please try again.';
    }
  });
})();
